import { SelectProps } from 'antd';
import InfiniteSelect from '../../InfiniteSelect';
import {
  useInvoiceGovermentCstDetail,
  useInvoiceGovermentCstList,
} from '@/core/domain/invoice/government/goverment.hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import {
  InvoiceGovernmentCst,
  InvoiceGovernmentCstListRequest,
} from '@/core/domain/invoice/government/government.types';
import { useMemo, useState } from 'react';
import { useDebounce } from '@/hooks';

interface Props extends SelectProps {
  queryParams: InvoiceGovernmentCstListRequest;
  queryEnabled?: boolean;
}

export default function SelectInvoiceCST({
  queryParams,
  queryEnabled,
  ...props
}: Props) {
  const [search, setSearch] = useState('');
  const searchDebouce = useDebounce(search);

  const cstList = useInvoiceGovermentCstList(
    { ...queryParams, search: searchDebouce },
    queryEnabled,
  );
  const cstDetail = useInvoiceGovermentCstDetail(props.value);

  const list = flatInfiniteData(cstList.data);

  const geCstLabel = (cst: InvoiceGovernmentCst) =>
    `${cst.code} - ${cst.description}`;

  const options = useMemo(() => {
    const items = list.map((cst) => ({
      value: cst.code,
      label: geCstLabel(cst),
    }));

    if (items.some((item) => item.value === props.value)) return items;

    if (cstDetail.data)
      return [
        { value: cstDetail.data?.code, label: geCstLabel(cstDetail.data) },
        ...items,
      ];

    return items;
  }, [list, cstDetail.dataUpdatedAt, props.value]);

  return (
    <InfiniteSelect
      {...props}
      options={options}
      fetchNextPage={cstList.fetchNextPage}
      hasNextPage={cstList.hasNextPage}
      loading={cstList.isLoading}
      searchValue={search}
      onSearch={setSearch}
    />
  );
}
